import React from 'react'
import { DeleteModalProps } from '../../types'
import { useRdnaNotification } from '@ringdna/common/src/components/RdnaNotification/RdnaNotificationContext'
import { useComplianceAnnouncementDelete } from '../../api'
import { getErrorMessage } from '@ringdna/common/src/utils/errorUtils'
import RdnaModal from '@ringdna/common/src/components/RdnaModal'
import SvgDelete from '@ringdna/common/src/assets/icons/svg/Delete'
import RdnaText from '@ringdna/common/src/components/RdnaText'

export default function ConfirmComplianceAnnouncementDeleteModal({ open, onClose, id, name }: DeleteModalProps) {
  const { error } = useRdnaNotification()
  const deleteComplianceAnnouncement = useComplianceAnnouncementDelete()
  async function handleDelete() {
    try {
      await deleteComplianceAnnouncement({ meta: { id: id } })
    } catch (e) {
      error(getErrorMessage(e))
    }
    onClose(true)
  }
  return (
    <RdnaModal
      open={open}
      cancelButtonText={'Cancel'}
      confirmButtonText={'Delete'}
      heading={`Delete Announcement`}
      headingIcon={<SvgDelete />}
      onClose={() => onClose(false)}
      onConfirm={handleDelete}
    >
      <RdnaText>{'You are about to delete the following compliance announcement:'}</RdnaText>
      <RdnaText style={{ marginTop: 12, marginBottom: 12 }} variant={'h5'} align={'center'} color={'link'}>
        {name}
      </RdnaText>
      <RdnaText>{'This action is irreversible and deleted files cannot be retrieved. Continue?'}</RdnaText>
    </RdnaModal>
  )
}
